export const ActionType = {
  SET_FLAGS: 'SET_FLAGS',
};
